/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetChallengeChallengeId200ResponseAllOf
 */
export interface GetChallengeChallengeId200ResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof GetChallengeChallengeId200ResponseAllOf
     */
    result?: string;
}

/**
 * Check if a given object implements the GetChallengeChallengeId200ResponseAllOf interface.
 */
export function instanceOfGetChallengeChallengeId200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetChallengeChallengeId200ResponseAllOfFromJSON(json: any): GetChallengeChallengeId200ResponseAllOf {
    return GetChallengeChallengeId200ResponseAllOfFromJSONTyped(json, false);
}

export function GetChallengeChallengeId200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengeChallengeId200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetChallengeChallengeId200ResponseAllOfToJSON(value?: GetChallengeChallengeId200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

